import React from "react";
import { Pizza, Clock, Loader2 } from "lucide-react";
import { DailyStats } from "../types";
import { formatTime } from "../utils/formatTime";

interface StatsCardProps {
  dailyStats: DailyStats;
}

export const StatsCard: React.FC<StatsCardProps> = ({ dailyStats }) => {
  return (
    <div className="mt-3 sm:mt-4">
      <div className="rounded-lg border border-white/20 bg-white/10 p-3 backdrop-blur-sm sm:rounded-xl sm:p-4">
        <div className="grid grid-cols-3 gap-2 text-center sm:gap-6">
          <div>
            <div className="mb-0.5 flex items-center justify-center space-x-1 sm:mb-1 sm:space-x-2">
              <Pizza className="h-4 w-4 text-orange-400 sm:h-5 sm:w-5" />
              <span className="text-xl font-black text-orange-300 sm:text-3xl">
                {dailyStats.pizzasFinalizadas}
              </span>
            </div>
            <p className="text-xs opacity-75 sm:text-sm">Total Produzidas</p>
          </div>
          <div>
            <div className="mb-0.5 flex items-center justify-center space-x-1 sm:mb-1 sm:space-x-2">
              <Loader2
                className={`h-4 w-4 text-amber-400 sm:h-5 sm:w-5 ${dailyStats.emProducao > 0 ? "animate-spin" : ""}`}
              />
              <span className="text-xl font-black text-amber-300 sm:text-3xl">
                {dailyStats.emProducao}
              </span>
            </div>
            <p className="text-xs opacity-75 sm:text-sm">Em Produção</p>
          </div>
          <div>
            <div className="mb-0.5 flex items-center justify-center space-x-1 sm:mb-1 sm:space-x-2">
              <Clock className="h-4 w-4 text-blue-400 sm:h-5 sm:w-5" />
              <span className="text-xl font-black text-blue-300 sm:text-3xl">
                {formatTime(dailyStats.tempoMedioGeral || 0)}
              </span>
            </div>
            <p className="text-xs opacity-75 sm:text-sm">Tempo Médio</p>
          </div>
        </div>
      </div>
    </div>
  );
};
